import { Attachment } from './attachment';
import { Model } from './model';
import { Type } from 'class-transformer';

export type EmailSenderProvider = 'google' | 'icloud' | 'imap' | 'sendgrid' | 'microsoft' | 'other';

export class EmailSender extends Model {
  id: string;

  email: string;

  /** Alias designated as the From address; null sends from `email`. */
  send_as: string | null = null;

  is_centralized_inbox: boolean = false;

  is_nylas_connection: boolean;

  is_nylas_grant_expired: boolean;

  is_sendgrid_sender: boolean = false;

  is_shared: boolean;

  name: string | null;

  provider: EmailSenderProvider | null;

  reply_to: string;

  reply_to_name: string | null;

  @Type(() => Attachment)
  signature_attachments: Attachment[];

  signature_html: string | null;

  state: string | null;

  user_id: string | null;

  // Hybrid mode fields
  is_hybrid_sender: boolean = false;

  paired_sendgrid_sender_id: string | null = null;

  is_paired_sendgrid_sender: boolean = false;

  can_send_via_sendgrid: boolean = false;

  can_send_via_nylas: boolean = false;
}
